var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "header" },
    [
      _c("div", { staticClass: "leftBar" }, [
        _c("span", { staticClass: "date" }, [_vm._v(_vm._s(_vm.nowDate1))]),
        _c("span", { staticClass: "week" }, [_vm._v(_vm._s(_vm.DateToday))]),
        _c("span", { staticClass: "time num" }, [_vm._v(_vm._s(_vm.nowTime))]),
        _c("div", [
          _c(
            "span",
            { staticClass: "flex cursor", on: { click: _vm.weatherClick } },
            [
              _c("img", { attrs: { width: "20px", src: _vm.form.code } }),
              _c("span", [_vm._v(_vm._s(_vm.form.sk_s))]),
              _c("span", [_vm._v(_vm._s(_vm.form.sk_t) + "°C")]),
            ]
          ),
        ]),
      ]),
      _c("div", { staticClass: "rightBar" }, [
        _c("div", { staticClass: "warn flex" }, [
          _c("div", [
            _c(
              "ul",
              {
                ref: "newList",
                staticClass: "new-list",
                on: {
                  mouseenter: function ($event) {
                    return _vm.Stop()
                  },
                  mouseleave: function ($event) {
                    return _vm.Up()
                  },
                },
              },
              _vm._l(_vm.list, function (item, index) {
                return _c(
                  "li",
                  {
                    key: index,
                    staticClass: "notice",
                    class: { anim: _vm.animate },
                    attrs: { title: item.info },
                    on: { click: _vm.warnClick },
                  },
                  [
                    _c("span", [_vm._v("[" + _vm._s(item.date) + "]")]),
                    _vm._v(" " + _vm._s(item.info) + " "),
                  ]
                )
              }),
              0
            ),
          ]),
          _c("img", {
            staticStyle: {
              "margin-left": ".09rem",
              "margin-right": ".12rem",
              padding: "3px 0",
            },
            attrs: { src: require("images/index/home/robot.png") },
          }),
          _vm.fromPath !== "newIndex"
            ? _c(
                "a",
                {
                  staticClass: "yyzx",
                  attrs: {
                    href: _vm.yyurl,
                    title: "茂名市荔枝优势产区产业园荔枝产业大数据中心",
                  },
                },
                [
                  _c("img", {
                    attrs: {
                      src: require("images/index/home/yyxt.png"),
                      alt: "",
                    },
                  }),
                  _c("p", [_vm._v("应用中心")]),
                ]
              )
            : _vm._e(),
        ]),
      ]),
      _vm._t("rightBtn"),
      _c("a", { staticClass: "click-area", on: { click: _vm.goHome } }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }